<template>
  <div class="d-flex flex-column gap" id="module_properties">
    <!-- Flyer -->
    <div class="flyer_container" v-if="mainStore.module.url_flyer != ''">
      <img :src="mainStore.module.url_flyer" alt="Flyer de l'épreuve" />
    </div>
    <div v-if="mainStore.is_default_mode">
      <!-- Limite de participants -->
      <div class="module_property" v-if="!mainStore.module.hide_nb_inscrits">
        <div class="text-body-1 rounded-circle pa-2 bg-grey_1 bordered">
          <v-icon icon="mdi-account-group" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Nombre de participants</div>
          <div class="text-subtitle-1 font-weight-bold">

            {{ mainStore.module.nb_inscrits }}<span v-if="mainStore.module.has_limite_participants_globale">/{{
              mainStore.module.metadatas.nb_limite_globale }}</span>
          </div>
        </div>
      </div>
      <!-- Transfert de dossards -->
      <div class="module_property">
        <div class="text-body-1 rounded-circle pa-2 bg-grey_1 bordered">
          <v-icon icon="mdi-account-arrow-left" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Transfert de dossards</div>
          <div class="text-subtitle-1 font-weight-bold">
            <div v-if="mainStore.module.autoriser_transfert_dossard">
              Autorisé
              <span v-if="mainStore.module.has_limite_transfert_dossard">
                jusqu'au {{ $moment(mainStore.module.metadatas.limite_transfert_dossard).format("D MMMM YYYY") }}
              </span>
            </div>
            <div v-else>Non autorisé</div>
          </div>
        </div>
      </div>
      <!-- Changement de course -->
      <div class="module_property">
        <div class="text-body-1 rounded-circle pa-2 bg-grey_1 bordered">
          <v-icon icon="mdi-swap-horizontal" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Changement de course</div>
          <div class="text-subtitle-1 font-weight-bold">
            <div v-if="mainStore.module.autoriser_changement_course">
              Autorisé
              <span v-if="mainStore.module.has_limite_changement_course">
                jusqu'au {{ $moment(mainStore.module.metadatas.limite_changement_course).format("D MMMM YYYY") }}
              </span>
            </div>
            <div v-else>Non autorisé</div>
          </div>
        </div>
      </div>
      <!-- Inscriptions multi courses -->
      <div class="module_property">
        <div class="text-body-1 rounded-circle pa-2 bg-grey_1 bordered">
          <v-icon icon="mdi-account-details" color="primary" size="large"></v-icon>
        </div>
        <div>
          <div>Inscription multi courses</div>
          <div class="text-subtitle-1 font-weight-bold">
            <div v-if="mainStore.module.inscription_plusieurs_courses">Autorisé</div>
            <div v-else>Non autorisé</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Action buttons -->
    <div class="d-flex flex-column justify-start flex-wrap sm-gap">
      <!-- Bouton accès fiche -->
      <router-link :to="{ name: 'FicheCoureur' }"><v-btn block color="primary-dark" prepend-icon="mdi-account"
          class="text-left">Accèder à ma fiche</v-btn></router-link>

      <!-- Bouton liste inscrits -->
      <div v-if="mainStore.is_default_mode">
        <!-- Lien page race -->
        <a v-if="mainStore.module.has_page_race"
          :href="'https://sportips.fr/race/' + mainStore.module.base + '/inscriptions'" target="_blank">
          <v-btn block color="dark" prepend-icon="mdi-format-list-numbered">Liste des participants</v-btn>
        </a>
        <!-- View liste inscrit -->
        <router-link v-else-if="!mainStore.module.hide_nb_inscrits" :to="{ name: 'InscriptionsList' }">
          <v-btn block color="dark" prepend-icon="mdi-format-list-numbered">Liste des participants</v-btn>
        </router-link>

      </div>
      <div>
        <!-- View bourse aux dossards -->
        <router-link v-if="mainStore.module.has_bourse_dossards" :to="{ name: 'BourseDossards' }">
          <v-btn block color="dark" prepend-icon="mdi-cash">Bourse aux dossards</v-btn>
        </router-link>
      </div>
      <!-- Lien réglement -->
      <a v-if="mainStore.module.url_reglement != ''" :href="mainStore.module.url_reglement" target="_blank">
        <v-btn block color="dark" prepend-icon="mdi-link">
          <span v-if="mainStore.is_default_mode">Réglement de l'épreuve</span>
          <span v-else>CGV de l'événement</span>
        </v-btn>
      </a>


      <!-- Lien du site -->
      <a v-if="mainStore.module.has_url_site" :href="mainStore.module.metadatas.url_site" target="_blank">
        <v-btn block color="dark" prepend-icon="mdi-link">
          <span v-if="mainStore.is_default_mode">Site de l'épreuve</span>
          <span v-else>Site de l'événement</span>
        </v-btn>
      </a>
      <!-- Lien facebook -->
      <a v-if="mainStore.module.has_url_fb" :href="mainStore.module.metadatas.url_fb" target="_blank">
        <v-btn block color="dark" prepend-icon="mdi-facebook">Facebook de l'épreuve</v-btn>
      </a>
      <!-- Lien contact Sportips -->
      <a href="https://sportips.fr/contact.php" target="_blank">
        <v-btn block color="dark" prepend-icon="mdi-email">Contacter Sportips</v-btn>
      </a>
      <!-- Extra buttons link -->
      <a class="extra_buttons_link" v-for="(extra, index) in extra_buttons" :key="index" :href="extra.valeur"
        target="_blank">
        <v-card color="dark" class="pa-1 text-button text-center" variant="tonal">
          <v-icon icon="mdi-link" class="mr-1"></v-icon>{{ extra.label }}
        </v-card>
      </a>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
  data() {
    return {
      extra_buttons: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  async created() {
    this.extra_buttons = await this.mainStore.module.get_extra_buttons_accueil();
  },
};
</script>

<style lang="scss" scoped>
.extra_buttons_link:hover {
  text-decoration: none !important;
}
</style>